export const Logo = ({ className = "" }) => (
  <div
    className={`font-display font-bold text-lg tracking-tight flex items-center gap-2.5 select-none ${className}`}
    data-testid="iqes-logo"
  >
    <div className="relative">
      <div className="w-7 h-7 rounded-xl flex items-center justify-center"
           style={{background: "linear-gradient(135deg, #003366 0%, #002244 100%)"}}>
        <span className="text-white font-mono text-[10px] leading-none font-bold">IQ</span>
      </div>
      <div className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-[#EA580C]" />
    </div>
    <div className="flex flex-col leading-none">
      <span className="text-[#003366]">IQES</span>
      <span className="font-normal text-[10px] text-slate-500 uppercase tracking-[0.15em] mt-0.5">IQ-APP</span>
    </div>
  </div>
);
